import _ from 'lodash';
import { createSelector } from 'reselect';
import { pendingResponse } from '../../../fetchStatus';
import { extraParamsSelector } from '../../util';
import { vehicleFilterStateSelector } from '../vehicleFilter';

// FIXME: duplicate categoryUrlSelector to fix race condition
//  This is caused by a combination and/or interaction of:
//  - createMatchSelector from connected-react-router
//  - frontload
//  - redux-thunk
const categoryUrlSelector = createSelector([extraParamsSelector], params => {
    const { categoryUrl } = params;
    if (_.isNil(categoryUrl) || !_.isString(categoryUrl) || _.isEmpty(categoryUrl)) {
        throw new Error(`Expected valid categoryUrl, instead got: ${categoryUrl}`);
    }
    return categoryUrl;
});

const productUrlSelector = createSelector([extraParamsSelector], params => {
    const { productUrl } = params;
    if (_.isNil(productUrl) || !_.isString(productUrl) || _.isEmpty(productUrl)) {
        throw new Error(`Expected valid productUrl, instead got: ${productUrl}`);
    }
    return productUrl;
});

const categoryStateByUrlSelector = createSelector([vehicleFilterStateSelector], vehicleFilterState => vehicleFilterState.category);

const categoryStateSelector = createSelector(
    [categoryStateByUrlSelector, categoryUrlSelector],
    (categoryStateByUrl, categoryUrl) => categoryStateByUrl?.[categoryUrl] ?? {}
);

export const productResponseByProductUrlSelector = createSelector([categoryStateSelector], categoryState => categoryState.product);

export const productResponseSelector = createSelector(
    [productResponseByProductUrlSelector, productUrlSelector],
    (productResponseByProductUrl, productUrl) => {
        return productResponseByProductUrl?.[productUrl] ?? pendingResponse;
    }
);
